export function getNonEmptySeriesArray(series, availableSeriesTypes) {
  return Object.keys(series).filter(type => availableSeriesTypes.has(type)).flatMap(type => {
    const seriesOfType = series[type];
    return seriesOfType.seriesOrder.filter(seriesId => seriesOfType.series[seriesId].data.length > 0 && seriesOfType.series[seriesId].data.some(value => value != null)).map(seriesId => ({
      type,
      seriesId
    }));
  });
}